import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function Privacy() {
  return (
    <Layout>
      <section className="border-b border-background-300 bg-background-200">
        <div className="mx-auto max-w-[900px] px-4 md:px-6 py-10 md:py-14">
          <div className="text-xs text-secondary-600 font-semibold tracking-widest">プライバシーポリシー</div>
          <h1 className="mt-2 text-2xl md:text-3xl font-bold text-foreground-900">情報の取り扱い</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7">スマホ代見直し案内所で、現在どのように情報を扱っているかを説明します。</p>
        </div>
      </section>

      <section className="mx-auto max-w-[900px] px-4 md:px-6 py-12 space-y-9 text-[15px] text-foreground-700 leading-8">
        <div>
          <h2 className="text-xl font-bold text-foreground-900">診断・請求書チェックの入力内容</h2>
          <p className="mt-3">料金診断と請求書チェックの計算は、ご利用中のブラウザ内で行います。入力した回答や金額を当サイト独自の会員データベースへ登録する機能はなく、現在の実装ではURLにも含めません。</p>
          <p className="mt-3">入力内容はページを再読み込みしたり閉じたりすると消えます。パスワード、認証コード、クレジットカード番号、本人確認書類などは入力しないでください。</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">お問い合わせで受け取る情報</h2>
          <p className="mt-3">メールでお送りいただいたメールアドレス、お名前、お問い合わせ内容は、内容の確認と返信のために使用します。契約内容の照会や手続きの代行はできません。</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">サイト配信と外部サービス</h2>
          <p className="mt-3">サイトの配信・保護にはCloudflareを利用しています。配信に伴い、IPアドレスや通信に関する情報がCloudflareで処理される場合があります。詳しくは<a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer" className="text-primary-500 underline">Cloudflareのプライバシーポリシー</a>をご確認ください。</p>
          <p className="mt-3">文字とアイコンの表示にはGoogle Fonts、cdnjs、Font Awesome、Remix Iconを利用しています。ページ表示時に各配信元へ通信が発生する場合があります。</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">アクセス解析・広告</h2>
          <p className="mt-3">当サイト独自のアクセス解析タグと会員登録機能は導入していません。一部の記事と料金診断ではA8.netと楽天アフィリエイトの成果報酬型広告を掲載しています。広告の表示やクリック時には各ASPへの通信が発生し、申込み先では広告主にも情報が送られます。広告のあるページには「PR」を表示します。</p>
          <p className="mt-3">A8.netは広告経由の申込みを計測するためにCookieを利用します。Cookieの取り扱いについては<a href="https://www.a8.net/privacy.html" target="_blank" rel="noreferrer" className="text-primary-500 underline">A8.netのプライバシーについて</a>をご確認ください。</p>
          <p className="mt-3">外部サイトへ移動した後の情報の取り扱いは、リンク先のプライバシーポリシー等をご確認ください。</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-foreground-900">お問い合わせ窓口</h2>
          <p className="mt-3">情報の取り扱いについてのご質問は、<Link to="/contact" className="text-primary-500 underline">お問い合わせページ</Link>からお送りください。</p>
        </div>
        <p className="text-xs text-foreground-500">更新日：2026年9月23日</p>
      </section>
    </Layout>
  );
}
